import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import User from "./userDetails";
import Dropdown from "components/inputs/dropdown";

interface MenuProps {
  selected: string;
  select: (menuItem: string) => void;
}
const Menu = ({ selected, select }: MenuProps) => {
  const menuItems = [
    "Artist Profile",
    "Artist Music Platforms",
    "Plan Artists",
    "Social Media"
  ];
  return (
    <Container>
      <User />
      <Items>
        {menuItems.map((menuItem, i) => {
          let active = selected === menuItem;
          return (
            <MenuItem
              key={i}
              isactive={active ? "true" : "false"}
              onClick={() => select(menuItem)}
            >
              {active ? <ActiveBar /> : ""}
              <Typography weight={active ? "semibold" : "regular"}>
                {menuItem}
              </Typography>
            </MenuItem>
          );
        })}
      </Items>

      <DropdownContainer>
        <Dropdown
          chosenItem={selected}
          items={menuItems}
          selectItem={(val) => select(val)}
        />
      </DropdownContainer>
    </Container>
  );
};

export default Menu;

const Container = styled.div`
  width: 100%;
  background-color: rgba(30, 30, 30, 0.5);
  border-radius: 0.8rem;
  backdrop-filter: blur(5px);
  z-index: 2;
  display: flex;
  flex-direction: column;
  height: fit-content;
  overflow: hidden;
  @media only screen and (max-width: 769px) {
    background-color: transparent;
    overflow: visible;
  }
`;

const Items = styled.div`
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;
const MenuItem = styled.div<{ isactive: string }>`
  width: 100%;
  text-align: center;
  position: relative;
  padding: 1.4rem 0;
  border-bottom: 0.5px solid #272727;
  cursor: pointer;
  color: ${(props) =>
    props.isactive === "true" ? Colors.white100 : Colors.grey600};
  background: ${(props) =>
    props.isactive === "true"
      ? "linear-gradient(90deg, rgba(28, 28, 28, 0.40) 0%, rgba(41, 41, 41, 0.40) 100%)"
      : ""};

  transition: all ease-in-out 0.2s;

  &:hover {
    background: linear-gradient(
      90deg,
      rgba(28, 28, 28, 0.4) 0%,
      rgba(41, 41, 41, 0.4) 100%
    );
    color: white;
  }
`;
const ActiveBar = styled.div`
  width: 1px;
  height: 80%;
  background-color: ${Colors.yellow400};
  position: absolute;
  left: 0;
  top: 10%;
`;

const DropdownContainer = styled.div`
  display: none;
  @media only screen and (max-width: 769px) {
    display: block;
  }
`;
